export default "__VITE_ASSET__B06LA0om__";